export const MODULES = {
  DASHBOARD: 'dashboard',
  CONFIGURATION: 'configuration',
  BOOKINGS: 'bookings',
  ACTIVE_SLOTS: 'active_slots',
  INDIVIDUAL_BOOKING: 'individual_booking',
  PAYMENTS: 'payments',
  REPORTS: 'reports',
  USERS: 'users',
  ROLES: 'roles',
  EQUIPMENT: 'equipment',
  OPERATIONS: 'operations',
  STAFF: 'staff',
  EXPENSES: 'expenses',
  HELP_CENTER: 'help_center',
  SELFIE_ATTENDANCE: 'selfie_attendance',
  TOURNAMENTS: 'tournaments',
};

export const AVAILABLE_MODULES = [
  { id: MODULES.DASHBOARD, name: 'Dashboard', description: 'Main dashboard view' },
  { id: MODULES.CONFIGURATION, name: 'Configuration', description: 'Facility and service configuration' },
  { id: MODULES.BOOKINGS, name: 'Bookings', description: 'View and manage bookings' },
  { id: MODULES.ACTIVE_SLOTS, name: 'Booked Slots', description: 'View booked and partially booked slots' },
  { id: MODULES.INDIVIDUAL_BOOKING, name: 'Individual Booking', description: 'Individual slot bookings' },
  { id: MODULES.PAYMENTS, name: 'Payments', description: 'Payment management' },
  { id: MODULES.REPORTS, name: 'Reports', description: 'View reports and analytics' },
  { id: MODULES.USERS, name: 'Users', description: 'User management' },
  { id: MODULES.ROLES, name: 'Roles', description: 'Role and permission management' },
  { id: MODULES.EQUIPMENT, name: 'Equipment', description: 'Equipment management' },
  { id: MODULES.OPERATIONS, name: 'Operations', description: 'Daily operations management' },
  { id: MODULES.STAFF, name: 'Staff', description: 'Staff management' },
  { id: MODULES.EXPENSES, name: 'Expenses', description: 'Expense tracking' },
  { id: MODULES.HELP_CENTER, name: 'Help Center', description: 'Help and support' },
  { id: MODULES.SELFIE_ATTENDANCE, name: 'Selfie Attendance', description: 'Selfie-based attendance tracking' },
  { id: MODULES.TOURNAMENTS, name: 'Tournaments', description: 'Tournament registration and team approvals' },
];

export const ROLE_NAMES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  STAFF: 'Staff',
};
